export default __webpack_public_path__ + "static/media/client-28.78a359be.webp";